// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"c304798f","739":"2d52a6a0"}[chunkId] + ".chunk.js";
};